// Task status constants
export const TASK_STATUS = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

// Task priority constants
export const TASK_PRIORITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  URGENT: 'urgent'
};

// Task type constants
export const TASK_TYPE = {
  MAINTENANCE: 'maintenance',
  REPLACEMENT: 'replacement',
  FIX: 'fix',
  OTHER: 'other'
}; 